




















































import VueOptions from '@utils/VueOptions'
import FormField from '@ui/FormBuilder/FormField'
import CreativeFields from '@ui/FormBuilder/ResourceFields/CreativeFields.coffee'

settings =
  name: 'CreativeForm'

  vue:
    props: ['wizard', 'form']

    components: {
      FormField,
    }

    computed:
      primaryType:
        get: -> @compact [@form.data.primary_type]
        set: ->

      fieldNameForAdditionalTypes: ->
        name = @formFields.types.name
        return name unless @form.data.types?.length > 0
        limit = @formFields.types.inputProps?.limit || 0
        remaining = limit - @form.data.types.length
        name = "#{name} (add up to #{remaining} more)" if remaining > 0
        name

      fieldNameForAudienceTags: ->
        name = @formFields.audience_tags.name
        return name unless @form.data.audience_tags?.length > 0
        limit = @formFields.audience_tags.inputProps?.limit || 0
        remaining = limit - @form.data.audience_tags.length
        name = "#{name} (add up to #{remaining} more)" if remaining > 0
        name

      fieldNameForActivityTags: ->
        name = @formFields.activity_tags.name
        return name unless @form.data.activity_tags?.length > 0
        limit = @formFields.activity_tags.inputProps?.limit || 0
        remaining = limit - @form.data.activity_tags.length
        name = "#{name} (add up to #{remaining} more)" if remaining > 0
        name

      fieldKeys: ->
        [
          'title'
          'primary_type'
          'types'
          'audience_tags'
          'activity_tags'
        ]

      formFields: ->
        fields = {}
        fields[key] = @creativeFields.fields[key] for key in @fieldKeys
        fields

      contextForCreativeFields: ->
        _requiredFields: ['title', 'primary_type']
        options:
          primary_type: @toSelectOptions(@$store.marketplace?.listing?.types)
          types: @toSelectOptions(@$store.marketplace?.listing?.types)
          audience_tags: @toSelectOptions(@$store.marketplace?.listing?.audiences)
          activity_tags: @toSelectOptions(@$store.marketplace?.listing?.activities)

      creativeFields: ->
        CreativeFields(@contextForCreativeFields)

    methods:
      hiLocationChange: (location) ->
        @form.data[key] = value for key, value of location

      hiAddTeamTrigger: (teamId) ->
        @wizard.bindTeamToVenueTrigger teamId

      hiRemoveTeamTrigger: (teamId) ->
        @wizard.unbindTeamToVenueTrigger teamId

      hiChangePrimaryType: ([tag]) ->
        @form.data.primary_type = tag
        @form.data.types = @compact [...new Set([tag, ...@form.data.types])]
        @wizard.saveField ['primary_type', 'types']
      hiChangeTypes: (types) ->
        @form.data.primary_type = null unless @form.data.primary_type in types
        @form.data.types = @compact types
        @wizard.saveField ['primary_type', 'types']

export default VueOptions.vue settings
